/* eslint-disable react/jsx-handler-names */
import { Box } from '@chakra-ui/react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { colors } from '../../../theme/colors';

const NationalityRatioChart = ({ data }: { data: any }) => {
  return (
    <Box width='100%' mt='16px'>
      <Box borderRadius='12px' margin='auto'>
        <ResponsiveContainer
          width='100%'
          height={Math.max(280, data.length * 40)}
        >
          <BarChart
            layout='vertical'
            data={data}
            margin={{
              left: 0,
              top: 10,
              right: 30,
              bottom: 5
            }}
          >
            <CartesianGrid
              strokeDasharray='3 3'
              stroke='#E2E8F0'
              vertical={true}
              horizontal={false}
            />
            <XAxis
              type='number'
              domain={[0, 'auto']}
              axisLine={false}
              tick={{ fontSize: 12, fill: colors.gray }}
              strokeWidth={0}
              allowDecimals={false}
            />
            <YAxis
              type='category'
              width={110}
              dataKey='name'
              axisLine={false}
              tick={{ fontSize: 12, fill: colors.gray }}
              strokeWidth={0}
              interval={0}
            />
            <Tooltip
              cursor={{ fill: 'rgba(0,0,0,0.04)' }}
              labelFormatter={() => ''}
              formatter={(val: any) => [val, 'Cases']}
              contentStyle={{
                backgroundColor: colors.white,
                borderRadius: 8,
                fontSize: '13px',
                border: `1px solid ${colors.shade}`,
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
              }}
            />
            <Bar
              name='Cases'
              dataKey='value'
              fill={colors.dark_green}
              barSize={14}
              radius={[0, 6, 6, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default NationalityRatioChart;
